import { propOr } from 'ramda';

import { replaceData, resetForm } from '@gef-ui/form-core/stream/transfer/control';
import { deleteTemporaryStore, updateTemporaryStore } from '@gef-ui/redux-common/actions/temporaryStore';
import { getTemporaryStore } from '@gef-ui/redux-common/selectors/temporaryStore';

import { REQUEST_SIZE } from 'constants/general';
import fetch from 'features/common/fetch';
import { saveFile } from 'features/common/fileSave/actions';
import { getUser } from 'features/views/user/selectors';
import userContext from 'features/views/userContext';
import { trimFormData } from 'utils';

import { SUBORDINATE_USERS_FORM_NAME } from './form';
import { actions } from './reducer';

const getFetchStorePath = (contextUser) =>
	`${fetch.constants.urls.userList}.${contextUser ? contextUser.login : 'root'}`;

export const loadMore = () => (dispatch, getState) => {
	const state = getState();
	const contextUser = userContext.selectors.getContextUser(state);
	const { queryParams } = fetch.selectors.getLastRequest(getFetchStorePath(contextUser))(state);
	dispatch(fetchSubordinateUsers(queryParams.page + 1, queryParams.sort, true, true));
};

export const handlePagination =
	(page = 0) =>
	(dispatch, getState) => {
		const state = getState();
		const contextUser = userContext.selectors.getContextUser(state);
		const { queryParams } = fetch.selectors.getLastRequest(getFetchStorePath(contextUser))(state);
		const sortType = propOr('surname,asc', 'sort', queryParams);
		dispatch(fetchSubordinateUsers(page, sortType, false, true));
	};

export const handleReload = () => (dispatch, getState) => {
	const state = getState();
	const contextUser = userContext.selectors.getContextUser(state);
	const { queryParams = {} } = fetch.selectors.getLastRequest(getFetchStorePath(contextUser))(state);
	dispatch(fetchSubordinateUsers(queryParams.page, queryParams.sort));
};

export const fetchSubordinateUsers =
	(page = 0, sort = ['surname,asc', 'firstName,asc'], append = false, paging = false) =>
	async (dispatch, getState, { getFormData }) => {
		const contextUser = userContext.selectors.getContextUser(getState());
		const { queryParams } = fetch.selectors.getLastRequest(getFetchStorePath(contextUser))(getState());
		const formData = await getFormData(SUBORDINATE_USERS_FORM_NAME);
		const data = trimFormData(formData);
		const dataSource = paging ? queryParams : data;
		const { searchForAllSubordinate, sellerIn, surname, firstName } = dataSource;

		dispatch(
			fetch.actions.get(fetch.constants.urls.userList, {
				uniqueReqID: contextUser ? contextUser.login : 'root',
				queryParams: {
					userHierarchy: 'subordinate',
					searchForAllSubordinate,
					sellerIn,
					surname,
					firstName,
					size: REQUEST_SIZE,
					page,
					sort,
				},
				additionalHeaders: contextUser ? { 'X-Context-User': contextUser.login } : {},
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;
						const data = response?.body?.data;

						if (append) {
							dispatch(actions.appendData(data));
						} else {
							dispatch(actions.setData(data));
						}
					},
				],
			}),
		);
	};

export const startupSubordinateUsers =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		sendControlNext(SUBORDINATE_USERS_FORM_NAME, resetForm());
		dispatch(fetchSubordinateUsers());
	};

export const saveFormToTemporaryStore =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const contextUser = userContext.selectors.getContextUser(getState());
		const currentForm = await getFormData(SUBORDINATE_USERS_FORM_NAME);
		const currentTempStorePath = `temporaryForms.${contextUser ? contextUser.login : 'root'}`;

		dispatch(deleteTemporaryStore(currentTempStorePath));
		dispatch(updateTemporaryStore(currentTempStorePath, currentForm));
	};

export const loadFormFromTemporaryStore =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		const contextUser = userContext.selectors.getContextUser(getState());
		const currentTempStorePath = `temporaryStore.temporaryForms.${contextUser ? contextUser.login : 'root'}`;
		const usersForm = getTemporaryStore(currentTempStorePath)(getState());

		sendControlNext(SUBORDINATE_USERS_FORM_NAME, replaceData({ data: usersForm ? usersForm : {} }));
	};

export const reportSubordinates = () => async (dispatch, getState) => {
	let userLogin = getUser(getState());
	const contextUser = userContext.selectors.getContextUser(getState());

	if (contextUser) {
		userLogin = contextUser.login;
	}

	const response = await dispatch(
		fetch.actions.getBinary(fetch.constants.urls.unfinishedTaskReport, {
			queryParams: {
				userLogin,
			},
		}),
	);

	saveFile({ response });
};
